/** Fullscreen belongs to the complete workspace; failure never changes its visual mode. */
export async function toggleWorkspaceFullscreen(
  workspace: Pick<HTMLElement, 'requestFullscreen'>,
  fullscreenDocument: Pick<Document, 'fullscreenElement' | 'exitFullscreen' | 'fullscreenEnabled'>,
): Promise<string | null> {
  try {
    if (fullscreenDocument.fullscreenElement === workspace) {
      await fullscreenDocument.exitFullscreen();
    } else {
      if (
        !fullscreenDocument.fullscreenEnabled ||
        typeof workspace.requestFullscreen !== 'function'
      ) {
        return '当前浏览器不支持全屏，可继续使用当前页面。';
      }
      await workspace.requestFullscreen();
    }
    return null;
  } catch {
    return fullscreenDocument.fullscreenElement === workspace
      ? '退出全屏失败，请重试或使用系统退出全屏操作。'
      : '浏览器未允许进入全屏，可重试或继续使用当前页面。';
  }
}
